export default __webpack_public_path__ + "static/media/songbird.cdc39722.svg";